<template>
  <div>
    <b-card>
      <h4>กล่องค้นหา</h4>
      <hr>
      <b-card-body class="d-flex">
        <div class="d-flex align-items-center mb-1">
          <span class="pr-1"> Date: </span>
          <flat-pickr v-model="date" class="form-control"/>
          <span class="px-1"> - </span>
          <span class="pr-1"> Due Date: </span>
          <flat-pickr v-model="dueDate" class="form-control mr-1"/>
          <b-button variant="primary" @click="getLoadShipment()">ค้นหา</b-button>
        </div>
      </b-card-body>
    </b-card>
    <b-card>
      <div v-if="loadpage == true" class="text-center">
        <b-spinner
          style="width: 5rem; height: 5rem;"
          variant="primary"
          label="Large Spinner"
        />
      </div>

      <b-tabs v-if="loadpage == false">
        <b-tab :title="this.unShippedCount">
          <b-card v-for="item in unShipped" :key="item.length">
            <h4 class="text-right font-weight-bolder">บิล : {{item.thaiPackingID}}</h4>
            <b-button class="float-right mb-1" variant="danger" size="sm" :to="{ name: 'finance-transfer'}">
              แจ้งชำระเงิน
            </b-button>
            <b-table
              responsive
              class="position-relative"
              :items="item.orderShipmentInfoItems"
              :fields="unShippedFields"
            >
              <template #cell(no)="data">
                {{data.value}}
              </template>
              <template #cell(receiveDate)="data">
                  {{formatDate_dmy(data.value)}}
              </template>
              <template #cell(offChinaDate)="data">
                  {{formatDate_dmy(data.value)}}
              </template>
              <template #cell(arrivedThaiDate)="data">
                  {{formatDate_dmy(data.value)}}
              </template>
              <template #cell(cubic)="data">
                  {{format_decimal(data.value)}}
              </template>
              <template #cell(itemPrice)="data">
                  {{format_price(data.value)}}
              </template>
              <template #cell(itemWeightRevised)="data">
                  {{format_price(data.value)}}
              </template>
            </b-table>
            <b-row>
              <b-col cols="6">
              </b-col>
              <b-col cols="6">
                <b-input-group class="align-items-center topnav">
                  <span class="title">โค้ดคูปอง</span>
                  <p class="vs"> </p>
                  <b-form-input v-model="coupon" size="sm"/>
                  <p class="vs"> </p>
                  <b-button variant="outline-primary" size="sm" @click="useCoupon(item.thaiPackingID)">
                      ใช้คูปอง
                  </b-button>
                  <b-table
                    responsive
                    class="position-relative pt-1"
                    :items="item.summaryInfos"
                    :fields="billFields"
                    thead-class="hidden_header"
                    bordered
                    small
                  >
                  </b-table>
                </b-input-group>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab :title="this.shippedCount">
          <b-card v-for="item in shipped" :key="item.length">
            <b-row>
              <b-col>
                <h4>ส่งวันที่ : {{formatDate_dmy(item.shippedDate)}}</h4>
              </b-col>
              <b-col>
                <h4 class="text-right font-weight-bolder">บิล : {{item.thaiPackingID}}</h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <h4>เลขแทรคส่งของ : {{item.shipTrack}}</h4>
              </b-col>
              <b-col v-if="item.isPaid == true">
                <span class="float-right">ชำระยอดแล้ว</span>
                <b-img right  :src="require('@/assets/Correct.png')"></b-img>
              </b-col>
              <b-col v-if="item.isNotPaid == true">
                <b-button class="float-right mb-1" variant="danger" size="sm" :to="{ name: 'finance-transfer'}">
                  แจ้งชำระเงิน
                </b-button>
              </b-col>
            </b-row>
            <b-table
              striped
              responsive
              :items="item.orderShipmentInfoItems"
              :fields="unShippedFields"
            >
              <template #cell(no)="data">
                {{data.index + 1}}
              </template>
              <template #cell(receiveDate)="data">
                {{formatDate_dmy(data.value)}}
              </template>
              <template #cell(offChinaDate)="data">
                {{formatDate_dmy(data.value)}}
              </template>
              <template #cell(arrivedThaiDate)="data">
                {{formatDate_dmy(data.value)}}
              </template>
              <template #cell(itemPrice)="data">
                {{format_price(data.value)}}
              </template>
              <template #cell(itemWeightRevised)="data">
                {{format_price(data.value)}}
              </template>
            </b-table>
            <b-row>
              <b-col cols="6">
              </b-col>
              <b-col cols="6">
                <b-table
                  responsive
                  class="position-relative"
                  :items="item.summaryInfos"
                  :fields="billFields"
                  thead-class="hidden_header"
                  small
                  bordered
                >
                </b-table>
              </b-col>
            </b-row>
            <hr class="mb-n1" style="border: 1px solid">
          </b-card>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
import {
  BTable, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, 
  BInputGroupAppend, BButton, BCardBody, BCard, BTabs, BTab, BSpinner, BRow, BCol, BImg,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { format_price, formatDate_dmy, format_decimal } from '@/views/global_function.js'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";
export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    flatPickr,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BCard,
    BTabs,
    BTab,
    BSpinner,
    BRow,
    BCol,
    BImg
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      date: new Date().fp_incr(-30),
      dueDate: new Date(),
      unShipped: [],
      shipped: [],
      sumBill: [],
      unShippedCount: '',
      shippedCount: '',
      coupon: '',
      loadpage: false,
      unShippedFields: [
        { key: 'no', label: 'No', },
        { key: 'itemOrderID', label:'ใบสั่งซื้อ' },
        { key: '', label:'ลำดับที่' },
        { key: 'goodsReceiveID', label: 'เลขแทรค' },
        { key: 'receiveDate', label:'รับของเข้าโกดัง', },
        { key: 'offChinaDate', label:'ออกจากจีน' },
        { key: 'arrivedThaiDate', label: 'ถึงไทยวันที่' },
        { key: 'itemWeightRevised', label:'น้ำหนัก' },
        { key: 'itemCubic1', label:'กว้าง' },
        { key: 'itemCubic2', label:'ยาว' },
        { key: 'itemCubic3', label: 'สูง' },
        { key: 'cubic', label:'ขนาด(คิว)' },
        { key: 'rate', label:'เรท' },
        { key: 'itemPrice', label:'ราคา' },
      ],
      billFields:[
        { key: 'description' },
        { key: 'amount'},
        { key: 'unit'},
      ],
    };
  },
  created() {
    this.getLoadShipment()
    this.getBill()
  },

  methods: {
    format_price,
    formatDate_dmy,
    format_decimal,
    async getLoadShipment() {
      this.loadpage = true
      var keepdata = []
      var axios = require('axios');
      var data = JSON.stringify({
        // "customerID": 1,
        "customerID": JSON.parse(localStorage.getItem('cusId')),
        "startDate": this.date,
        "endDate": this.dueDate,
      });

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/order/shipment/load-order-shipment-page',
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
        'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.unShipped = keepdata.dataUnShipped
      this.shipped = keepdata.dataShipped
      this.unShippedCount = "ยังไม่ส่ง " + "(" + this.unShipped.length + ")"
      this.shippedCount = "ส่งแล้ว " + "(" + this.shipped.length + ")"
      this.loadpage = false
    },
    async getBill(){
      var keepdata = []
      var axios = require('axios');
      var data = JSON.stringify({
        "thaiPackingID": "TH658994",
      });

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/order/shipment/load-order-shipment-info-page',
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
        'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.sumBill = keepdata
    },
    async useCoupon(id){
      var axios = require('axios');
      var data = JSON.stringify({
        // "customerID": 1,
        "loginToken": this.userData.data.customerInfo.loginToken,
        "thaiPackingID": id,
        "couponCode": this.coupon
      });

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/order/shipment/use-coupon-code',
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
        'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then(function (response) {
      })
      .catch(function (error) {
        console.log(error);
      });
      await this.getBill()
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style scoped lang="scss">
p {
  margin: 0;
}

.topnav {
  display: flex;
}

.topnav .vs {
  padding-right: 10px;
  padding-left: 10px;
}
</style>
<style>
.hidden_header {
  display: none;
}
</style>